import { create } from 'zustand'

export type ConnectionStatus = {
  status: 'connected' | 'disconnected' | 'reconnecting'
  reconnectIn?: number // milliseconds until reconnect
  timestamp?: number // timestamp of status change
}

export type Winner = 'player' | 'opponent' | 'tie'

type AppState = {
  updateState: <T>(key: string, value: T) => void
  loaded?: boolean
  userLoaded?: boolean
  delta?: number
  errors?: { [key: string]: string }
  loginSuccess?: boolean
  params?: { [key: string]: string }[]
  modalRuleStatus?: boolean
  modalTicketClaimStatus?: boolean
  modalReferralStatus?: boolean
  modalRankStatus?: boolean
  modalExchangeStatus?: boolean
  modalHistoryStatus?: boolean
  modalMatchMakingStatus?: boolean
  modalMatchResultStatus?: boolean
  modalLotteryStatus?: boolean
  modalListRewardStatus?: boolean
  refreshSuccess?: boolean
  isPreparing?: boolean
  isDisconnected?: boolean

  stateLoaded?: boolean
  isAniming?: boolean
  connectionStatus?: ConnectionStatus
  winner?: Winner
  getParam: (key: string) => string
  getError: (error: any) => string
  closeAllModals: () => void
}

const modalStatusKeys = [
  'modalRuleStatus',
  'modalTicketClaimStatus',
  'modalReferralStatus',
  'modalRankStatus',
  'modalExchangeStatus',
  'modalHistoryStatus',
  'modalMatchMakingStatus',
  'modalLotteryStatus',
  'modalListRewardStatus',
  'modalMatchResultStatus',
] as const

export const useStore = create<AppState>(
  (set, get) =>
    ({
      loaded: false,
      userLoaded: false,
      delta: 0,
      errors: {},
      params: [],
      loginSuccess: false,
      modalRuleStatus: false,
      modalReferralStatus: false,
      modalRankStatus: false,
      modalExchangeStatus: false,
      modalLotteryStatus: false,
      modalListRewardStatus: false,
      modalHistoryStatus: false,
      modalMatchMakingStatus: false,
      modalMatchResultStatus: false,
      isPreparing: false,
      isDisconnected: false,
      modalTicketClaimStatus: false,
      stateLoaded: false,
      isAniming: false,
      gameState: null,
      connectionStatus: { status: 'connected', timestamp: Date.now() },
      opponentInfo: null,
      winner: 'tie',
      refreshSuccess: false,
      getParam: (key: string) => {
        const params = get().params
        return params?.[key as any] as any
      },
      getError: (error: any) => {
        const errors = get().errors
        const key = (error?.code || error?.message) as string
        return (
          errors?.[key] ||
          `Hệ thống chưa thể thực hiện thao tác của bạn: ${key}`
        )
      },
      updateState: <T>(key: string, value: T) =>
        set(() => ({
          [key]: value,
        })),
      closeAllModals: () =>
        set(() =>
          Object.fromEntries(modalStatusKeys.map((key) => [key, false])),
        ),
    }) as any as AppState,
)
